import React from "react";
import styles from "./button-icon.module.css";
import IconSvg from "../icon-svg/icon-svg";
import { AppIcon } from "../icon-svg/app-icon.model";

type ButtonIconColor =
  | "primary"
  | "accent"
  | "background"
  | "transparent"
  | "background-light"
  | "dark";

type IconColor =
  | "primary"
  | "accent"
  | "background"
  | "background-light"
  | "text";

type ButtonIconProps = {
  icon: AppIcon;
  onClick: () => void;
  classes?: string;
  color?: ButtonIconColor;
  iconColor?: IconColor;
  disabled?: boolean;
};

const ButtonIcon: React.FC<ButtonIconProps> = ({
  icon,
  onClick,
  classes = "",
  color = "primary",
  iconColor = "text",
  disabled = false,
}) => {
  const buttonClass = `${styles.buttonContainer} ${styles[color]} ${classes}`;
  const iconClass = `${styles.buttonIconSvg} ${iconColor}`;

  return (
    <button
      type="button"
      className={`button-icon ${buttonClass}`}
      onClick={onClick}
      disabled={disabled}
    >
      <IconSvg path={icon} className={iconClass} />
    </button>
  );
};

export default ButtonIcon;
